import Close from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { ReactNode } from "react";
import { INK, INK_BLACK, SURFACE } from "../../theme/tokens";
import { SystemReactTinyPopover } from "../UIToolkit/Popups/SystemReactTinyPopover";

interface InformationalPopupProps {
	isOpen: boolean;
	title: string;
	content: ReactNode | string;
	imageUrl?: string;
	onClose: () => void;
	positions?: ("top" | "bottom" | "left" | "right")[];
	align?: "start" | "center" | "end";
	children?: ReactNode;
}

export const InformationalPopup: React.FC<InformationalPopupProps> = ({
	isOpen,
	title,
	content,
	imageUrl,
	onClose,
	positions = ["bottom", "top", "right", "left"],
	align = "start",
	children,
}) => {
	return (
		<SystemReactTinyPopover
			data-testid={"informational-popup"}
			isOpen={isOpen}
			positions={positions}
			align={align}
			contentRootStyle={{
				background: SURFACE,
				borderRadius: 12,
				boxShadow: `0 10px 30px ${alpha(INK_BLACK, 0.12)}`,
				padding: 10,
				minWidth: 280,
				maxWidth: 320,
				zIndex: 10001,
			}}
			content={
				<Box>
					<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
						<IconButton size="small" onClick={onClose} sx={{ p: 0 }}>
							<Close fontSize="small" />
						</IconButton>
					</Box>
					<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
						{imageUrl && <Box component="img" src={imageUrl} alt={title} sx={{ width: "100%", maxWidth: 200, height: "auto" }} />}
						<Typography variant="body2" sx={{ textAlign: "center", color: INK.SECONDARY, fontWeight: "600", fontSize: "16px" }}>
							{title}
						</Typography>
						{content && (
							// A div, not body2's <p>: `content` may be a node with its own block elements, and <p> cannot contain them.
							<Typography variant="body2" component="div" sx={{ textAlign: "center", color: INK.SECONDARY, fontWeight: "600", fontSize: "14px" }}>
								{content}
							</Typography>
						)}
					</Box>
				</Box>
			}
			arrowOpacity={1}
		>
			{children || <div />}
		</SystemReactTinyPopover>
	);
};
